import type { RowResult } from '../../utils/csvParser'

interface Props {
  rows: RowResult[]
}

const sizeLabel: Record<string, string> = {
  small: 'Petit', medium: 'Moyen', large: 'Grand', extra: 'Extra',
}

export const ImportCSVPreviewTable = ({ rows }: Props) => (
  <div style={{ overflowX: 'auto', maxHeight: 320, overflowY: 'auto' }}>
    <table style={{
      width: '100%', borderCollapse: 'collapse',
      fontSize: 12, fontFamily: 'DM Sans, sans-serif',
    }}>
      <thead>
        <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
          {['#', 'Statut', 'Nom', 'Téléphone', 'Adresse', 'Taille', 'Prix', 'Paiement'].map(h => (
            <th key={h} style={{
              color: 'rgba(255,255,255,0.4)', fontWeight: 600,
              padding: '8px 12px', textAlign: 'left',
              position: 'sticky', top: 0, background: '#1A1C1E',
            }}>
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr
            key={row.index}
            style={{
              borderBottom: '1px solid rgba(255,255,255,0.04)',
              background: row.valid ? 'transparent' : 'rgba(255,77,79,0.05)',
            }}
          >
            <td style={{ padding: '8px 12px', color: 'rgba(255,255,255,0.35)' }}>
              {row.index}
            </td>
            <td style={{ padding: '8px 12px' }}>
              {row.valid ? (
                <span style={{ color: '#1D9E75', fontWeight: 600 }}>✓ OK</span>
              ) : (
                <span title={row.errors.join('\n')} style={{ color: '#FF4D4F', fontWeight: 600, cursor: 'help' }}>
                  ✕ {row.errors.length} erreur{row.errors.length > 1 ? 's' : ''}
                </span>
              )}
            </td>
            <td style={{ padding: '8px 12px', color: row.valid ? '#fff' : 'rgba(255,255,255,0.4)' }}>
              {row.raw.contact_name || '—'}
            </td>
            <td style={{ padding: '8px 12px', color: row.valid ? '#fff' : 'rgba(255,255,255,0.4)' }}>
              {row.raw.contact_phone ? `+216 ${row.raw.contact_phone}` : '—'}
            </td>
            <td style={{
              padding: '8px 12px',
              color: row.valid ? '#fff' : 'rgba(255,255,255,0.4)',
              maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>
              {row.raw.dropoff_address || '—'}
            </td>
            <td style={{ padding: '8px 12px', color: row.valid ? '#fff' : 'rgba(255,255,255,0.4)' }}>
              {sizeLabel[row.raw.size || 'medium'] ?? (row.raw.size || 'Moyen')}
            </td>
            <td style={{ padding: '8px 12px', color: row.valid ? '#1D9E75' : 'rgba(255,255,255,0.4)', fontWeight: 600 }}>
              {row.raw.price ? `${row.raw.price} TND` : '—'}
            </td>
            <td style={{ padding: '8px 12px', color: row.valid ? '#fff' : 'rgba(255,255,255,0.4)' }}>
              {row.raw.payment_method === 'cash' ? '💵 Cash'
                : row.raw.payment_method === 'online' ? '💳 Online'
                : '—'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    {rows.some(r => !r.valid) && (
      <div style={{ marginTop: 12, padding: '0 4px' }}>
        {rows.filter(r => !r.valid).map(row => (
          <div key={row.index} style={{ marginBottom: 6 }}>
            <span style={{ color: '#FF4D4F', fontWeight: 600, fontSize: 12 }}>
              Ligne {row.index} :
            </span>
            <ul style={{ margin: '2px 0 0 16px', padding: 0 }}>
              {row.errors.map((err, i) => (
                <li key={i} style={{ color: 'rgba(255,77,79,0.85)', fontSize: 11 }}>{err}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    )}
  </div>
)
